import { Day } from '@/api/restaurants/types/restaurant-types'
import { ITranslationKey } from '@/components/t'

export function parseReadableDay(day: Day, t: (tKey: ITranslationKey) => string): string {
    switch (day) {
        case 'monday':
            return t('shared.days.monday')

        case 'tuesday':
            return t('shared.days.tuesday')

        case 'wednesday':
            return t('shared.days.wednesday')

        case 'thursday':
            return t('shared.days.thursday')

        case 'friday':
            return t('shared.days.friday')

        case 'saturday':
            return t('shared.days.saturday')

        default:
            return t('shared.days.sunday')
    }
}
